import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(3);

  useEffect(() => {
    const tick = setInterval(() => {
      setSeconds((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    const redirect = setTimeout(() => {
      navigate("/", { replace: true });
    }, 3000);
    return () => {
      clearInterval(tick);
      clearTimeout(redirect);
    };
  }, [navigate]);

  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 via-white to-slate-50 px-6"
    >
      <div className="max-w-md w-full text-center">
        <p className="text-7xl font-black tracking-tight text-emerald-600">404</p>
        <h1 className="mt-4 text-2xl font-bold text-slate-900">
          This hole isn&apos;t on the course
        </h1>
        <p className="mt-3 text-base text-slate-600">
          The page you&apos;re looking for doesn&apos;t exist. We&apos;ll take you back to the
          tee box in{" "}
          <span
            data-testid="not-found-countdown"
            className="font-semibold text-emerald-700"
          >
            {seconds}
          </span>{" "}
          {seconds === 1 ? "second" : "seconds"}.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="not-found-home-btn"
            className="inline-flex items-center justify-center rounded-full bg-emerald-600 px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-emerald-700 transition"
          >
            Back to Home
          </Link>
          <a
            href="mailto:support@swingshape.se"
            data-testid="not-found-support-link"
            className="inline-flex items-center justify-center rounded-full border border-slate-300 bg-white px-6 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition"
          >
            Contact support@swingshape.se
          </a>
        </div>
      </div>
    </div>
  );
}
